import { defineComponent } from 'vue';
import { logOut } from 'ionicons/icons';
import { Auth } from '@/services/AuthService';
import { IonItem, IonIcon, IonLabel } from '@ionic/vue';
export default defineComponent({
    name: "LogoutButton",
    setup() {
        const handleSignOut = () => {
            Auth.Instance.signOut();
        };
        return { logOut, handleSignOut };
    },
    props: {
        icon: {
            type: Boolean,
            default: false
        }
    },
    components: {
        IonItem,
        IonIcon,
        IonLabel
    }
});
